// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__FX0mR","info":"Note_info__77AgD","note":"Note_note__3P8di","actions":"Note_actions__3eqaq"};